import * as React from "react";
const StackHorizontalSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M14 3h-3c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1Zm0 11h-3V4h3v10ZM7 3H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1Zm0 11H4V4h3v10Z" }));
StackHorizontalSmall.displayName = "StackHorizontalSmall";
var StackHorizontalSmall_default = StackHorizontalSmall;
export {
  StackHorizontalSmall_default as default
};
